export const LANGUAGES_TRANSLATE = {
    languages: {
        breadcrumbName: "Idiomas",
        messages: {
            create: "Idioma creado con éxito",
            update: "Idioma actualizado con éxito",
            delete: "Idioma eliminado con éxito",
            recover: "Idioma recuperado con éxito"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Nombre",
                    tag: "Etiqueta"
                }
            },
            filters: {
                fields: {
                    active: {
                        label: "Estado",
                        placeholder: "Seleccione el estado",
                        url: "estado"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Desactivar idioma",
                    body: "¿Está seguro de que desea desactivar el idioma con ID {{id}}?",
                    save: { text: "Sí, desactivar" },
                    back: { text: "Volver" }
                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre del idioma"
                    },
                    tag: {
                        label: "Etiqueta",
                        placeholder: "Ej: es-ES"
                    },
                    active: {
                        label: "Activo"
                    },
                    countryFlag: {
                        label: "Ícono de la bandera",
                        noResultsLabel: "Ninguna imagen seleccionada",
                        noResultsDescription: "Haga clic para seleccionar una imagen de la bandera",
                        textButton: "Seleccionar imagen",
                        changeTextButton: "Cambiar imagen"
                    }
                }
            }
        }
    }
};
